import script from "./RequestsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./RequestsDropdown.vue?vue&type=style&index=0&id=72c7ffcf&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c7ffcf"]])

export default __exports__